import * as React from "react";

import {
  InitialStateMinimumRequirements_Pack_JoinDrawerFull,
} from "../../../Common";

interface ReactWishlistGuestInitialStateConsumerInterface {
  initialState: ReactWishlistGuestInitialState;
}

interface ReactWishlistGuestInitialState
  extends InitialStateMinimumRequirements_Pack_JoinDrawerFull {}

const defaultValue =
  {} as unknown as ReactWishlistGuestInitialStateConsumerInterface;

const ReactWishlistGuestInitialStateContext = React.createContext(defaultValue);

interface ReactWishlistGuestInitialStateProviderProps {
  mountElement: Element | null;
}

export const ReactWishlistGuestInitialStateProvider: React.FunctionComponent<
  ReactWishlistGuestInitialStateProviderProps
> = (props) => {
  const initialState = React.useMemo(() => {
    const mountElement = (props.mountElement || {}) as HTMLElement;

    const initialStateJsonString =
      mountElement?.dataset.reactWishlistguest__initialstate || "{}";

    const initialState = JSON.parse(
      initialStateJsonString
    ) as ReactWishlistGuestInitialState;
    return initialState;
  }, [props.mountElement]);
  const value: ReactWishlistGuestInitialStateConsumerInterface = React.useMemo(
    () => ({
      initialState,
    }),
    [initialState]
  );
  return (
    <ReactWishlistGuestInitialStateContext.Provider value={value}>
      {props?.children || []}
    </ReactWishlistGuestInitialStateContext.Provider>
  );
};

export const useReactWishlistGuestInitialState = () => {
  const context = React.useContext(ReactWishlistGuestInitialStateContext);
  if (context === defaultValue) {
    throw new Error(
      "useReactWishlistGuestInitialState must be used within a ReactWishlistGuestInitialStateProvider"
    );
  }
  return context;
};
